import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Investor Relations section for selections tab
 */
const InvestorRelationsSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="investor-relations-section-component"
    >
      <AccordionV2
        testId="investor-relations"
        className="border-x py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Best Investor Relations" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 pt-4">
          <p>
            The selection and judging process consists of a three-stage process:
          </p>

          <p>
            In Stage 1, all listed companies are subjected to a preliminary
            screening using the following sources:
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              The company&apos;s Singapore Governance and Transparency Index
              score;
            </li>

            <li>
              Dedicated IR link and IR contact on the company&apos;s website
              and/or annual report;
            </li>
          </ul>

          <p>
            In Stage 2, a final shortlist of companies is identified using the
            criteria (described below).
          </p>

          <p>
            In Stage 3, a panel of judges reviews and evaluates the shortlisted
            candidates based on the information provided by the companies and
            evaluators.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default InvestorRelationsSection;
